/**
 * Marks a floating surface that renders through a **portal** — i.e. its DOM node is a child of
 * `document.body`, not of the component that logically owns it (MUI `Popper`, `Drawer`, …).
 *
 * Outside-click detection is DOM-containment based, so a portaled surface reads as "outside" its
 * own opener. When such a surface is nested inside another popup (e.g. the SystemDropdown panel
 * inside a SystemReactTinyPopover), picking an option would tear the parent popup down mid-edit.
 * Stamping the surface with this attribute lets those handlers recognise the click as logically
 * inside and ignore it.
 */
export const PORTAL_OVERLAY_ATTRIBUTE = "data-portal-overlay";

/** Convenience spread for JSX: `{...portalOverlayProps("dropdown-panel")}`. */
export const portalOverlayProps = (surface: string): Record<string, string> => ({ [PORTAL_OVERLAY_ATTRIBUTE]: surface });

/** True when the event target sits inside a portaled UIToolkit overlay (see `PORTAL_OVERLAY_ATTRIBUTE`). */
export const isInsidePortalOverlay = (target: EventTarget | null): boolean =>
	target instanceof Element && target.closest(`[${PORTAL_OVERLAY_ATTRIBUTE}]`) !== null;
